import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from "react-router-dom";

import {
    Box
    } from '@amzn/awsui-components-react';
import './history.scss'
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { useAuth } from "../../context/AuthContextProvider";
import { getFriscoTransaction} from "src/Ateam-BI/Templates/Utils/AppActivityUtils"


const FriscoRedirect = (props) => {

    const userAuthenticationDetails = useAuth();
    const history = useHistory();
    const userLDAPS = userAuthenticationDetails.USER_LDAP_GROUPS;
    const [error, setError] = useState(false);

    let { fid } = useParams();

    useEffect(() => {

        redirect(fid)
        return () => {
          // this now gets called when the component unmounts
        };
      }, []);

    const redirect = (fid) => {
        getFriscoTransaction(fid, function onSuccess(result){
            let appId = result.data?.getFRISCOTransactions?.appId
            let processId = result.data?.getFRISCOTransactions?.processId
            if(appId && processId){
                history.push(`/App/${appId}/process/${processId}/history`)
            }else{
                setError(true)
            }
        }, function onFailure(response){
            setError(true)
        })
    }


    return (
        <Box textAlign="center">
            {
                error?
                <Box variant="h1" color="text-status-error">Invalid file id</Box> :<Box variant="h1">Redirecting to the FRISCO history page..</Box>
            }
        </Box>
    )
}



export default FriscoRedirect

